import { Clickable, OnEscapeListener } from '@carvana/vdp-components';
import { useCallback, useContext, useMemo, useState } from 'react';
import SearchSource from '~/constants/SearchSource';
import SortOption from '~/constants/SortOption';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import SortIcon from './SortIcon';
import SortModal from './SortModal';
import useSortItems from './useSortItems';

export default function SortButton() {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { setSortBy, sortBy } = useContext(AppliedFiltersContext);
  const [isOpen, setOpen] = useState(false);
  const sortItems = useSortItems();

  const toggle = useCallback(() => setOpen(v => !v), []);
  const sortedBy = useMemo(
    () => sortItems.find(s => s.key === sortBy)?.label,
    [sortBy, sortItems]
  );

  return (
    <div className="relative">
      <Clickable
        className="flex"
        onClick={() => setOpen(v => !v)}
        data-analytics-id="Sort Button"
        data-qa="sort-button"
      >
        <SortIcon className="mr-8 self-center" />
        <p className="m-0">
          Sort <span className="hidden m:inline">by {sortedBy}</span>
        </p>
      </Clickable>
      {isOpen && (
        <OnEscapeListener onEscape={toggle}>
          <Clickable
            className="bg-[#00000080] fixed h-full inset-0 w-full z-[11]"
            onClick={toggle}
            data-analytics-id={null}
          />
          <SortModal
            selectedSortByItemKey={sortBy}
            sortItems={sortItems}
            toggleSortOrderModal={toggle}
            updateSortOrder={(key: SortOption) => {
              setSortBy(key);
              setSearchSource(SearchSource.SortBy);
            }}
          />
        </OnEscapeListener>
      )}
    </div>
  );
}
